import {
  Button,
  Drawer,
  Flex,
  Typography,
  useDrawerContext,
} from '@iheartjane/reefer';
import { useNavigate } from 'react-router';

import EmptyBag from '@jane/shared/assets/EmptyBag.svg?react';
import { useEcommApp } from '@jane/shared/providers';
import { monolithPaths as paths } from '@jane/shared/util';

import { CartDrawerStatesWrapper } from './cartDrawer.styles';

export const CartDrawerEmpty = () => {
  const navigate = useNavigate();
  const { appMode } = useEcommApp();
  const { onRequestClose } = useDrawerContext();

  const handleClick = () => {
    onRequestClose();
    if (appMode === 'default') {
      return navigate(paths.products());
    }

    return navigate(paths.embeddedMenu());
  };

  return (
    <>
      <Drawer.Header title="Bag" />
      <Drawer.Content noPadding>
        <CartDrawerStatesWrapper p={40}>
          <Flex
            flexDirection="column"
            alignItems="center"
            width="100%"
            my="auto"
          >
            <EmptyBag />
            <Typography mt={24} color="grays-mid" textAlign="center">
              Your bag is empty. Tap to explore all local cannabis products!
            </Typography>
            <Button
              mt={24}
              full
              onClick={handleClick}
              label="Shop all products"
            />
          </Flex>
        </CartDrawerStatesWrapper>
      </Drawer.Content>
    </>
  );
};
